import React, { useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  useParams,
} from "react-router-dom";
import AmlPage from "./pages/AML";
import ConfirmationGate from "./pages/ConfirmationGate";
import {
  Modal,
  Typography,
  TextField,
  Button,
  CircularProgress,
  Grid,
} from "@mui/material";
import {
  service,
  getAuthToken,
  getStoredUid,
  getStoredPath,
  clearAuthToken,
} from "./model/service";
import Header from "./components/Header";
import ModalOtpExpired from "./components/Generics/ModalOtpExpired";

function InvalidModal({ isIta }) {
  return (
    <>
      <div
        style={{ display: "flex", flexDirection: "column", height: "100vh" }}
      >
        <div style={{ position: "fixed", top: 0, width: "100%", zIndex: 1000 }}>
          <Header />
        </div>
      </div>
      <Modal open disableEscapeKeyDown>
        <Grid
          container
          item
          xs={11}
          md={5}
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "#fff",
            maxHeight: "90%",
            borderRadius: "16px",
            zIndex: 1300,
            overflow: "auto",
            outline: "none",
          }}
        >
          <Grid
            item
            xs={12}
            sx={{
              height: 60,
              display: "flex",
              alignItems: "center",
              borderBottom: "1px solid #c6c6c6",
              px: "20px",
            }}
          >
            <Grid item xs={1.5} md={0.5} sx={{ ml: 0 }}>
              <div className="icon-modal-info" />
            </Grid>
            <Grid item xs={10.5} md={11.5}>
              <Typography
                className="color-blue-dark"
                sx={{ fontSize: 18, fontWeight: 600, ml: 1 }}
              >
                {isIta ? "Accesso non autorizzato" : "Unauthorized access"}
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs={12} sx={{ display: "flex", flexDirection: "column" }}>
            <Typography
              className="color-blue-dark"
              sx={{
                padding: "50px 20px",
                fontSize: { xs: "14px", md: "16px" },
              }}
            >
              {isIta
                ? "Il modulo AML non è valido o è scaduto. Contatta l'amministrazione per ricevere un nuovo link."
                : "The AML form is not valid or has expired. Please contact the administration to receive a new link."}
            </Typography>
          </Grid>
        </Grid>
      </Modal>
    </>
  );
}

const PATH_LANGUAGE_MAP = {
  "persona-fisica": "ita",
  "persona-giuridica": "ita",
  "natural-person": "eng",
  "legal-person": "eng",
};

const PATH_TYPE_MAP = {
  "persona-fisica": "PF",
  "persona-giuridica": "PG",
  "natural-person": "PF",
  "legal-person": "PG",
};

function OtpGate() {
  const { uid } = useParams();
  const { pathname } = useLocation();
  const [linkScaduto, setLinkScaduto] = useState(false);

  const pathSegment = pathname.replace(/^\//, "").split("/")[1];
  const otpLanguage = PATH_LANGUAGE_MAP[pathSegment] || "ita";
  const isIta = otpLanguage === "ita";
  const expectedType = PATH_TYPE_MAP[pathSegment];

  const [verified, setVerified] = useState(() => {
    const tokenPresente = !!getAuthToken();
    const uidCorretto = getStoredUid() === uid;
    const pathCorretto = getStoredPath() === pathSegment;

    if (tokenPresente && (!uidCorretto || !pathCorretto)) {
      clearAuthToken();
      return false;
    }

    return tokenPresente && uidCorretto && pathCorretto;
  });

  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [unauthorized, setUnauthorized] = useState(false);
  const [otpExpired, setOtpExpired] = useState(false);

  const handleConfirm = async () => {
    if (!otp.trim()) {
      setError(isIta ? "Inserisci il codice OTP." : "Enter the OTP code.");
      return;
    }
    setLoading(true);
    setError("");
    try {
      await service.verifyOtp({ token: uid, otp, pathSegment });
      setVerified(true);
    } catch (err) {
      if (err.message === "OTP scaduto.") {
        setOtpExpired(true);
      } else if (err.message === "LINK_SCADUTO") {
        setError("");
        setLinkScaduto(true);
      } else if (err.message === "OTP non corretto.") {
        setError(isIta ? "OTP non corretto." : "Incorrect OTP.");
      } else {
        setError(isIta ? "OTP non valido." : "Invalid OTP.");
      }
    } finally {
      setLoading(false);
    }
  };

  if (!PATH_LANGUAGE_MAP[pathSegment]) return <h1>404: Pagina non trovata</h1>;
  if (unauthorized) return <InvalidModal isIta={isIta} />;

  if (linkScaduto)
    return (
      <>
        <div
          style={{ display: "flex", flexDirection: "column", height: "100vh" }}
        >
          <div
            style={{ position: "fixed", top: 0, width: "100%", zIndex: 1000 }}
          >
            <Header />
          </div>
        </div>
        <Modal open disableEscapeKeyDown>
          <Grid
            container
            item
            xs={11}
            md={5}
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              backgroundColor: "#fff",
              maxHeight: "90%",
              borderRadius: "16px",
              zIndex: 1300,
              overflow: "auto",
              outline: "none",
            }}
          >
            <Grid
              item
              xs={12}
              sx={{
                height: 60,
                display: "flex",
                alignItems: "center",
                borderBottom: "1px solid #c6c6c6",
                px: "20px",
              }}
            >
              <Grid item xs={1.5} md={0.5} sx={{ ml: 0 }}>
                <div className="icon-modal-otp" />
              </Grid>
              <Grid item xs={10.5} md={11.5}>
                <Typography
                  className="color-blue-dark"
                  sx={{ fontSize: 18, fontWeight: 600, ml: 1 }}
                >
                  {isIta ? "Procedura scaduta" : "Procedure expired"}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{ display: "flex", flexDirection: "column" }}
            >
              <Typography
                className="color-blue-dark"
                sx={{
                  padding: "50px 20px",
                  fontSize: { xs: "14px", md: "16px" },
                }}
              >
                {isIta ? (
                  <>
                    Questa procedura è inattiva in quanto il link di accesso è
                    scaduto. Per riattivare la procedura di raccolta dati ai
                    fini anti-riciclaggio scrivere a{" "}
                    <a
                      href="mailto:amministrazione@lexia.it"
                      className="color-purple"
                    >
                      amministrazione@lexia.it
                    </a>
                    .
                  </>
                ) : (
                  <>
                    This procedure is inactive as the access link has expired.
                    To reactivate the anti-money laundering data collection
                    procedure, please write to{" "}
                    <a
                      href="mailto:amministrazione@lexia.it"
                      className="color-purple"
                    >
                      amministrazione@lexia.it
                    </a>
                    .
                  </>
                )}
              </Typography>
            </Grid>
          </Grid>
        </Modal>
      </>
    );
  if (otpExpired)
    return (
      <>
        <div
          style={{ display: "flex", flexDirection: "column", height: "100vh" }}
        >
          <div
            style={{ position: "fixed", top: 0, width: "100%", zIndex: 1000 }}
          >
            <Header />
          </div>
        </div>
        <Modal open disableEscapeKeyDown>
          <ModalOtpExpired
            isIta={isIta}
            onClose={() => setOtpExpired(false)}
            uid={uid}
          />
        </Modal>
      </>
    );
  if (verified)
    return (
      <AmlPage uid={uid} expectedType={expectedType} isItaFallback={isIta} />
    );

  return (
    <>
      <div
        style={{ display: "flex", flexDirection: "column", height: "100vh" }}
      >
        <div style={{ position: "fixed", top: 0, width: "100%", zIndex: 1000 }}>
          <Header />
        </div>
      </div>

      <Modal open disableEscapeKeyDown>
        <Grid
          container
          item
          xs={11}
          md={5}
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "#fff",
            maxHeight: "90%",
            borderRadius: "16px",
            zIndex: 1300,
            overflow: "auto",
            outline: "none",
          }}
        >
          {/* Header */}
          <Grid
            item
            xs={12}
            sx={{
              height: 60,
              display: "flex",
              alignItems: "center",
              borderBottom: "1px solid #c6c6c6",
              px: "20px",
            }}
          >
            <Grid item xs={1.5} md={0.5} sx={{ ml: 0 }}>
              <div className="icon-modal-otp" />
            </Grid>
            <Grid item xs={10.5} md={11.5}>
              <Typography
                className="color-blue-dark"
                sx={{ fontSize: 18, fontWeight: 600, ml: 1 }}
              >
                {isIta ? "Autenticazione" : "Authentication"}
              </Typography>
            </Grid>
          </Grid>

          {/* Body */}
          <Grid
            item
            xs={12}
            md={10}
            sx={{ display: "flex", flexDirection: "column" }}
          >
            <Typography
              className="color-blue-dark"
              sx={{
                padding: "10px 15px 0px 15px",
                marginTop: "20px",
                fontSize: { xs: "14px", md: "16px" },
              }}
            >
              {isIta
                ? "Inserisci il codice OTP ricevuto alla tua casella email per accedere alla procedura di raccolta dati ai fini anti-riciclaggio."
                : "Enter the OTP code received in your email inbox to access the anti-money laundering data collection procedure."}
            </Typography>
            <Grid sx={{ padding: "20px 15px 0px 15px", minHeight: "90px" }}>
              <Typography className="color-blue-dark title-input">
                {isIta ? "Codice OTP" : "OTP Code"}
              </Typography>
              <TextField
                placeholder={isIta ? "Inserisci" : "Insert"}
                value={otp}
                onChange={(e) => {
                  const val = e.target.value.replace(/\D/g, "");
                  setOtp(val);
                  setError("");
                }}
                onKeyDown={(e) => e.key === "Enter" && handleConfirm()}
                error={!!error}
                helperText={error || " "}
                fullWidth
                inputProps={{ maxLength: 6 }}
                autoFocus
                FormHelperTextProps={{ sx: { marginLeft: "2px" } }}
              />
            </Grid>
          </Grid>

          {/* Footer */}
          <Grid container item xs={12} style={{ marginTop: "20px" }}>
            <Grid
              item
              xs={12}
              style={{
                display: "flex",
                justifyContent: "flex-end",
                padding: "20px",
              }}
            >
              <Button
                className={
                  loading || otp.trim().length !== 6
                    ? "button-bg-purple-disable"
                    : "button-bg-purple"
                }
                onClick={handleConfirm}
                disabled={loading || otp.trim().length !== 6}
                sx={{
                  height: "40px",
                  width: { xs: "120px", md: "140px" },
                }}
              >
                {loading ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  <Typography
                    className="color-light"
                    sx={{
                      textTransform: "initial",
                      fontSize: { xs: "14px", sm: "16px" },
                      fontWeight: 500,
                    }}
                  >
                    {isIta ? "Conferma" : "Confirm"}
                  </Typography>
                )}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Modal>
    </>
  );
}

export default function Root() {
  return (
    <Router>
      <Routes>
        <Route path="/aml/persona-fisica/:uid" element={<OtpGate />} />
        <Route path="/aml/persona-giuridica/:uid" element={<OtpGate />} />
        <Route path="/aml/natural-person/:uid" element={<OtpGate />} />
        <Route path="/aml/legal-person/:uid" element={<OtpGate />} />
        <Route path="/aml/conferma/:token" element={<ConfirmationGate isIta={true} />} />
        <Route path="/aml/confirmation/:token" element={<ConfirmationGate isIta={false} />} />
        <Route path="*" element={<h1>404: Pagina non trovata</h1>} />
      </Routes>
    </Router>
  );
}
